<template>
  <md-toolbar md-elevation="0" class="points-top-box">
    <div class="md-toolbar-row on-row desktop-row">
      <div class="md-toolbar-section-start">
        <img src="/img/swampum-polygon.png" alt="Swampum" width="45" height="45"/>
      </div>
      <md-content class="current-points md-elevation-1">
        <div class="points-content">
          <span class="pointsum">{{ formatPoints(myPointsSum) }}</span>
          <span class="text-sum">points available</span>
        </div>
      </md-content>

      <div class="md-toolbar-section-end">
        <router-link to="/s-app/earn-swampum-points"
          ><h4 class="earn-points-title">How to earn points?</h4></router-link
        >
      </div>
    </div>
    <div class="md-toolbar-row on-row mobile-row">
      <div class="md-toolbar-section-start mobile">
        <img src="/img/swampum-polygon.png" alt="Swampum" width="35" height="35"/>
        <span class="pointsum-mobile">{{ formatPoints(myPointsSum) }}</span>
      </div>

      <div class="md-toolbar-section-end mobile">
        <router-link to="/s-app/earn-swampum-points"
          ><h5 class="earn-points-title">How to earn points?</h5></router-link
        >
      </div>
    </div>
    <div class="md-toolbar-row on-row mobile-row">
      <div class="md-toolbar-section-start">
        <span class="text-sum-mobile">points available</span>
      </div>
    </div>
  </md-toolbar>
</template>

<script>
import UserHelperVue from "../../mixins/UserHelper.vue";
import PointsHelperVue from "@/mixins/PointsHelper.vue";
export default {
  name: "PointsAreaTopBox",
  mixins: [UserHelperVue, PointsHelperVue],
  methods: {
    formatPoints(swampumPoints) {
      return Number(swampumPoints).toLocaleString('en-US')
    }
  }
};
</script>

<style lang="scss" scoped>
.md-toolbar {
  background: $white;
}
.md-toolbar-section-start.mobile {
  flex: unset;
}

.md-toolbar-section-end.mobile {
  margin-left: 15px;
}

.current-points {
  background: #f4f4f4;
  border: 1px solid rgba(0, 0, 0, 0.13);
  border-radius: 6px;
  width: 17rem;
  min-height: 3.5rem;
  display: flex;
  align-items: center;
  justify-content: center;
}
.on-row {
  padding: 0.5rem 0 1rem 0;
  display: flex;
  justify-content: space-between;
}
.pointsum {
  font-size: 27px;
}
.pointsum, .pointsum-mobile {
  margin-right: 0.5rem;
  font-weight: bold;
  color: $primary;
}
.pointsum-mobile {
  margin: .25em 0 0 .75em;
  font-size: 20px;
}
.text-sum {
  font-size: 18px;
}
.text-sum-mobile {
  font-size: 13px;
  margin-top: -37px;
  font-weight: bold;
}
.points-content {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;
}
.earn-points-title,
.pointsum {
  color: $primary;
}
.earn-points-title,
.text-sum {
  letter-spacing: 1.25px;
}
.earn-points-title {
  font-weight: normal;
  text-align: right;
  font-size: 18px;
  margin: 0;
}
.mobile-row {
  margin-top: .237rem;
}
@media screen and (max-width:768px){
  .desktop-row {
    display: none;
  }
}
@media screen and (min-width:769px){
  .mobile-row {
    display: none;
  }
}
</style>
